import { all } from 'redux-saga/effects'

import authenticationSaga from './authenticationSaga'
import projectBoardSaga from './projectBoardSaga'
import listingSaga from './listingSaga'

export default function* () {
  yield all([...authenticationSaga, ...projectBoardSaga, ...listingSaga])
}
